"use client";

// src/blur-image.tsx
import { cn } from "@momo/utils";
import NextImage from "next/image";
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
var BlurImage = (props) => {
  const { alt, src, className, imageClassName, lazy = true, ...rest } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  return /* @__PURE__ */ jsx("div", { className: cn("overflow-hidden", className), children: /* @__PURE__ */ jsx(
    NextImage,
    {
      className: cn(
        "transition-all duration-700 ease-in-out",
        isLoading && !hasError && "scale-[1.02] opacity-70 blur-sm",
        !isLoading && "scale-100 opacity-100 blur-0",
        hasError && "opacity-50",
        imageClassName
      ),
      src,
      alt,
      loading: lazy ? "lazy" : void 0,
      priority: !lazy,
      quality: 100,
      onLoad: () => {
        setIsLoading(false);
        setHasError(false);
      },
      onError: () => {
        setIsLoading(false);
        setHasError(true);
      },
      ...rest
    }
  ) });
};

export {
  BlurImage
};
